/* ---------------------------------------------
 * ContractStatusCheckboxes.vue
 * ------------------------------------------- */
<template>
  <div>
    <v-checkbox
      v-if="contractStatus === 'Factură finală'"
      v-model="localDepusa"
      label="Decontare depusă"
      density="compact"
      @change="$emit('update-contract-status', 'Decontare depusă')"
      hide-details
    />
    <v-checkbox
      v-if="contractStatus === 'Decontare depusă'"
      v-model="localDecontat"
      label="Decontat"
      density="compact"
      @change="$emit('update-contract-status', 'Decontat')"
      hide-details
    />
  </div>
</template>

<script>
export default {
  name: "ContractStatusCheckboxes",
  props: {
    contractStatus: String,
    isDecontareDepusa: Boolean,
    isDecontat: Boolean,
  },
  data() {
    return {
      localDepusa: this.isDecontareDepusa,
      localDecontat: this.isDecontat,
    };
  },
  watch: {
    localDepusa(val) {
      this.$emit("update:is-decontare-depusa", val);
    },
    localDecontat(val) {
      this.$emit("update:is-decontat", val);
    },
  },
};
</script>
